import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController, IonContent, AlertController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import * as uuid from 'uuid';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-versiondetail',
  templateUrl: './versiondetail.page.html',
  styleUrls: ['./versiondetail.page.scss'],
})
export class VersiondetailPage implements OnInit {
  @ViewChild('content', { static: false }) private content: IonContent;
  @ViewChild("textarea") inputElement: ElementRef;
  templateId: any;
  versionId: any;
  locale: any;
  templocale: any;
  category: any;
  versionForm: FormGroup;
  versionDetail: any = {};
  showPage: boolean;
  selectedFiles: any = {};
  isChildPresent: boolean;
  title: any;
  isNodeSelect: boolean = false;
  isTemplateNodeSelect: boolean = false;
  data: any;
  templateFieldList: any = [];
  nodeSelected: boolean = false;
  dragNodeArray: any = [];
  submitted = false;
  afterNodeSelected: boolean;
  nodeCounter: number = 0;
  type: any;
  dataType: any = [];
  questionFieldDataType: any = [];
  documentQuestionSection: any = [];
  documentTemplateFieldList: any = [];
  bookmarkValue: any = {}
  selectedTemplateFiles: any = {}
  QuestionList: any = [];
  AllLocales: any = [];
  arraydocumentquestions: any = [];
  arraydocumentquestionfieldvalues: any = [];
  arraydocumentquestionsections: any = [];
  arraydocumentquestionfields: any = [];
  arraydocumentquestionfieldfollowup: any = [];
  documentTemplate: any = {};
  items: any = [];
  treeExpand: boolean = false;
  templateTreeExpand: boolean = true;
  toggleTemplateTooltip: string;
  toggleVersionTooltip: string;
  vesionData: any = {};
  treeTouched: boolean = false;
  questionSupportType: any = [];
  documentTemplateFields: any = [];
  dataTypeValue = '';
  dataTypeMapping: any = [];
  bookmarkTemplateFields = [];
  dataTypeMappingList: any = [];
  searchDescription: string = "";
  searchDocumentBookmarkName: string = "";
  previousBookmarkValue: any;
  previousQuestionFields: any;

  constructor(public alertController: AlertController, private router: Router, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location) { }

  ngOnInit() {

    this.toggleTemplateTooltip= this._commonService.getLocalTranslation('label-collapseAll');
    this.toggleVersionTooltip= this._commonService.getLocalTranslation('label-expandAll');
    this.versionForm = this.formBuilder.group({
      DocumentName: ['', Validators.required],
      Version: [''],
      Archive: ['1'],


    });
  }

  ionViewDidEnter() {
    this.dataTypeValue = '';
    this.templateId = this.route.snapshot.paramMap.get('id');
    this.versionId = this.route.snapshot.paramMap.get('versionid');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.templocale = this.locale;
    this.category = 'algemeen';
    // this.getDocumentTemplateDataType();
    // this.getDocumentQuestionFieldDataTypes();
    // this.getDocumentTemplateFieldList();
    // this.getDocumentQuestionDataTypeMapping();
    this.getAllData();
    this.getLocales();
    // if (this.versionId) {
    //   this.getVersionDetails();
    //   this.getTemplateDetails();
    //   this.getQuestionTree();
    // }
    this.vesionData =
    {
      DocumentTemplateId: this.templateId,
      DocumentTemplateVersionId: this.versionId,
      FileName: "",
      VersionNumber: "",
      IsArchive: ""
    }

  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {

        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
        localStorage.domainLocales = JSON.stringify(localeData.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  getAllData() {
    try {
      this._commonService.presentLoading();

      let bookmarkType = this._apiService.getTemplateDataType();
      let questionDataType = this._apiService.getDocumentQuestionFieldDataTypes();
      let supportList = this._apiService.getHelpTextList('', '', '', 1, 0, 'Module_DocumentGenerator');
      let fieldList = this._apiService.getDocumentTemplateFieldList(this.versionId);
      let dataTypeMapping = this._apiService.getDocumentQuestionDataTypeMapping();
      let detail = this._apiService.getVersionDetails(this.versionId);
      let bookmarkTree = this._apiService.getTemplateField(this.versionId);
      let questionTree = this._apiService.getVersionTreeDetails(this.versionId);
      let templateInfo = this._apiService.getTemplateDetails(this.templateId);
      forkJoin([bookmarkType, questionDataType, supportList, fieldList, dataTypeMapping,detail,bookmarkTree,questionTree,templateInfo]).subscribe( result => {
        this.dataType = result[0]['body'];

        this.questionFieldDataType = result[1]['body'];

        this.questionSupportType = result[2]['body'];

        this.documentTemplateFieldList = result[3]['body'];

        this.dataTypeMapping = result[4]['body'];
        this.dataTypeMapping.forEach(element => {
          element.translatedDescription = this._commonService.getLocalTranslation(element.Description);
        });
        this.dataTypeMapping.sort((a, b) => {
          if (a.translatedDescription.toLowerCase().trim() > b.translatedDescription.toLowerCase().trim()) {
            return 1;
        }
        if (a.translatedDescription.toLowerCase().trim() < b.translatedDescription.toLowerCase().trim()) {
            return -1;
        }
        return 0;
        });

        this.versionDetail = result[5]['body'];

        sessionStorage.TemplateName = result[8]['body'].Name;
        sessionStorage.VersionName =  result[8]['body'].VersionNumber ?  result[8]['body'].VersionNumber : '';
        sessionStorage.VersionId =  result[8]['body'].ActiveDocumentTemplateVersionId;

        this.title = sessionStorage.TemplateName
        this.versionForm.patchValue({
          DocumentName: this.versionDetail.FileName,
          Version: this.versionDetail.VersionNumber,
          Archive: Number(this.versionDetail.IsArchive) ? true : false,
        })
        this.isNodeSelect = true;

        this.templateFieldList = result[6]['body'];
        if (this.templateFieldList) {
          this.templateFieldList.forEach(element => {
            this.traverseTemplate(element);
            this.reverseIt(element);
          });
        }
        //this.checkTemplateBookmarks(this.templateFieldList);
        this.isTemplateNodeSelect = true;

        this.QuestionList = [];
        this.QuestionList.push(result[7]['body']);
        if (this.QuestionList) {
          this.QuestionList.forEach(element => {
            this.traverse(element);
          });
          this.changeLocale();
        }

        if (this.selectedFiles.constructor === Object && Object.keys(this.selectedFiles).length === 0) {
          this.type = 'documenttemplate';
          this.isNodeSelect = true;
        } else {
          this.isNodeSelect = true;
          this.type = this.selectedFiles[0].type.toLowerCase()
          let id = null
          if (this.type == 'documentquestionfieldvalues') {
            id = this.selectedFiles[0].documentQuestionFieldValueId

          } else if (this.type == 'documentquestionsections') {
            id = this.selectedFiles[0].DocumentQuestionSectionId

          } else if (this.type == 'documentquestions') {
            id = this.selectedFiles[0].documentQuestionId

          }
          else if (this.type == 'documentquestionfields') {
            id = this.selectedFiles[0].documentQuestionFieldId

          }
          else {
            id = this.selectedFiles[0].documentTemplateId

          }
          //this.getDetail(this.type, id)
        }
        this.showPage = true;
        this._commonService.dismiss();
      }, error => {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      });
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }


  }

  ionViewDidLeave() {
    this.isNodeSelect = false;
    this.treeTouched = false;
    this.isTemplateNodeSelect = false;
    this.showPage = false;
    this.versionForm.controls['DocumentName'].setErrors(null);
    this.nodeSelected = false;
    sessionStorage.removeItem('TemplateName')
    sessionStorage.removeItem('VersionName')
    sessionStorage.removeItem('VersionId')

  }

  async getDocumentTemplateDataType() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateDataType();
      this.dataType = res.body;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }



  async getDocumentQuestionFieldDataTypes() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getDocumentQuestionFieldDataTypes();
      this.questionFieldDataType = res.body;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getDocumentTemplateFieldList() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getDocumentTemplateFieldList(this.versionId);
      this.documentTemplateFieldList = res.body;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getDocumentQuestionDataTypeMapping() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getDocumentQuestionDataTypeMapping();
      this.dataTypeMapping = res.body;
      this.dataTypeMapping.forEach(element => {
        element.translatedDescription = this._commonService.getLocalTranslation(element.Description);
      });
      this.dataTypeMapping.sort((a, b) => {
        if (a.translatedDescription.toLowerCase().trim() > b.translatedDescription.toLowerCase().trim()) {
          return 1;
      }
      if (a.translatedDescription.toLowerCase().trim() < b.translatedDescription.toLowerCase().trim()) {
          return -1;
      }
      return 0;
      })
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getTemplateDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateField(this.versionId);
      this.templateFieldList = res.body;
      if (this.templateFieldList) {
        this.templateFieldList.forEach(element => {
          this.traverseTemplate(element);
          //this.reverseIt(element);
        });
      }
      //this.checkTemplateBookmarks(this.templateFieldList);
      this.isTemplateNodeSelect = true;
      this._commonService.dismiss();
      this.showPage = true;

    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getQuestionTree() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getVersionTreeDetails(this.versionId);
      this.QuestionList = [];
      this.QuestionList.push(res.body);
      if (this.QuestionList) {
        this.QuestionList.forEach(element => {
          this.traverse(element);
        });
        this.changeLocale();
      }
      let response = await this._apiService.getTemplateDetails(this.templateId);
      this.documentTemplate = response.body;
      if (this.selectedFiles.constructor === Object && Object.keys(this.selectedFiles).length === 0) {
        this.type = 'documenttemplate';
        this.isNodeSelect = true;
      } else {
        this.isNodeSelect = true;
        this.type = this.selectedFiles[0].type.toLowerCase()
        let id = null
        if (this.type == 'documentquestionfieldvalues') {
          id = this.selectedFiles[0].documentQuestionFieldValueId

        } else if (this.type == 'documentquestionsections') {
          id = this.selectedFiles[0].DocumentQuestionSectionId

        } else if (this.type == 'documentquestions') {
          id = this.selectedFiles[0].documentQuestionId

        }
        else if (this.type == 'documentquestionfields') {
          id = this.selectedFiles[0].documentQuestionFieldId

        }
        else {
          id = this.selectedFiles[0].documentTemplateId

        }
        //this.getDetail(this.type, id)
      }




      this.showPage = true;
      this._commonService.dismiss();
    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getVersionDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getVersionDetails(this.versionId);
      this.versionDetail = res.body;
      this.title = sessionStorage.TemplateName
      this.versionForm.patchValue({
        DocumentName: this.versionDetail.FileName,
        Version: this.versionDetail.VersionNumber,
        Archive: Number(this.versionDetail.IsArchive) ? true : false,
      })
      // await this.getQuestionTree()
      // await this.getTemplateDetails();
      this.isNodeSelect = true;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onChangeBreadcrumb() {
    this.versionDetail.VersionNumber = this.versionForm.value.Version;
  }

  checkTemplateBookmarks(arr) {

    arr.forEach(element => {
      if(element.documentQuestionTemplateFields && element.documentQuestionTemplateFields.length == 0) {
        var obj = {
          documentQuestionId: null,
          documentQuestionFieldId: null,
          documentQuestionFieldValueId: null
        }
        element.documentQuestionTemplateFields.push(obj);
      }
      if(element.children && element.children.length > 0) {
        let item = element.children.filter(x => x.iconColor == 'red')
        if(item.length == 0) {
          element.iconColor = 'green';

        } else {
          if(element.documentQuestionTemplateFields && element.documentQuestionTemplateFields.length > 0 && element.documentQuestionTemplateFields[0].documentQuestionId){
            element.iconColor = 'green';
          } else {
            element.iconColor = 'red';
          }
        }
        this.checkTemplateBookmarks(element.children)
      }
    })
  }

  reverseIt(obj) {
    if (!obj.children) {
      return obj;
    }
    if (obj.children.some(c => c.children)) {
      obj.children = obj.children.map(child => this.reverseIt(child));
    }
    let redColor = obj.children.find(x => x.iconColor == 'red');
    if(!redColor) {
      let bookmarkType = this.dataType.find(x=> x.DocumentBookmarkTypeId == obj.documentBookmarkTypeId);
      if(bookmarkType && bookmarkType.SystemTranslationCode == "DocBookmarkType_Parent") {
        obj.iconColor = 'green';
      }
    }

    return obj;
  }

  traverse(root) {
    if(root.type == 'DocumentTemplate'){
      root.expanded = true;
    }

    root.isNodeEnabled = true;
    if (root.children) {
      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        child.isNodeEnabled = true;
        if (child.children && child.children.length > 0) {
          this.traverse(child);
        }
      }
    }
  }

  traverseTemplate(root) {
    root.expanded = true;
    root.isNodeEnabled = true;
    this.toggleBookmarkColor(root);
    if (root.children) {
      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        child.isNodeEnabled = true;
        this.toggleBookmarkColor(child);
        if (child.children && child.children.length > 0) {
          this.traverseTemplate(child);
        }
      }
    }
  }

  toggleBookmarkColor(root) {
    let bookmarkType = this.dataType.find(x=> x.DocumentBookmarkTypeId == root.documentBookmarkTypeId);
    if(bookmarkType && bookmarkType.SystemTranslationCode == 'DocBookmarkType_Parent') {
      if(root.children && root.children.find(x => x.iconColor == "red")) {
        root.iconColor = 'red';
      } else {
        root.iconColor = 'green';
      }
    } else {
      if(root.documentQuestionTemplateFields && root.documentQuestionTemplateFields.length > 0 && root.documentQuestionTemplateFields[0].documentQuestionId) {
        root.iconColor = 'green';
      } else {
        root.iconColor = 'red';
      }
    }
  }

  toggleTree() {
    this._commonService.presentLoading();
    this.treeExpand = !this.treeExpand;
    if(this.treeExpand == true){
      this.toggleVersionTooltip = this._commonService.getLocalTranslation('label-collapseAll')
    }else{
      this.toggleVersionTooltip = this._commonService.getLocalTranslation('label-expandAll')
    }
    setTimeout(() => {
      if (this.QuestionList) {
        this.traverseToggleExpand(this.QuestionList);
      }
      this._commonService.dismiss();
    }, 500);
  }

  toggleTemplateTree() {
    this._commonService.presentLoading();
    this.templateTreeExpand = !this.templateTreeExpand;
    if(this.templateTreeExpand == true){
      this.toggleTemplateTooltip = this._commonService.getLocalTranslation('label-collapseAll')
    }else{
      this.toggleTemplateTooltip = this._commonService.getLocalTranslation('label-expandAll')
    }
    setTimeout(() => {
      if (this.templateFieldList) {
        this.traverseTemplateToggleExpand(this.templateFieldList);
      }
      this._commonService.dismiss();
    }, 500);
  }

  traverseToggleExpand(folders) {
    for (const root of folders) {
      if(root.type == 'DocumentQuestionSections' || root.type == 'DocumentQuestions' || root.type == 'DocumentQuestionFields' || root.type == 'DocumentQuestionFieldValues' || root.type == 'DocumentQuestionFollowup'){
        root.expanded = this.treeExpand;
      }
      //root.expanded = this.treeExpand;
      if (root.children && root.children.length > 0) {
        this.traverseToggleExpand(root.children);
      }
    }
  }

  traverseTemplateToggleExpand(folders) {
    for (const root of folders) {
      root.expanded = this.templateTreeExpand;
      if (root.children && root.children.length > 0) {
        this.traverseTemplateToggleExpand(root.children);
      }
    }
  }

  onSectionChanged(event) {

  }

  async getNodeDetails(event) {
    let id = null;
    if (event) {
      this.type = event.node.type.toLowerCase();
    }
    // this.traverseParent(event.node)
    this.isNodeSelect = true
    this.treeTouched = true
    if (this.type == 'documentquestionfieldvalues') {
      id = event.node.documentQuestionFieldValueId

    } else if (this.type == 'documentquestionsections') {
      id = event.node.DocumentQuestionSectionId

    } else if (this.type == 'documentquestions') {
      id = event.node.documentQuestionId

    }
    else if (this.type == 'documentquestionfields') {
      id = event.node.documentQuestionFieldId

    }
    else {
      id = event.node.documentTemplateId

    }
    //await this.getDetail(this.type, id)
    setTimeout(() => {
      if (this.content) {
        this.content.getScrollElement().then(el => {
          if (el) {
            this.content.scrollToPoint(0, 0, 0);
          }
        });
      }
    }, 100);
  }

  async onNodeSelect(event) {
    this.resetSelection(this.QuestionList, 'isNodeNew');
    if (event.node.children && event.node.children.length == 0) {
      this.isChildPresent = false;
    } else {
      this.isChildPresent = true;
    }
    let newNode = document.querySelector('.isNode-new');
    if (newNode) newNode.classList.remove("isNode-new");

    this.isNodeSelect = true
    let id = null;
    if (event.node.type.toLowerCase() == 'documentquestionfieldvalues') {
      id = event.node.documentQuestionFieldValueId
      if(!this.selectedFiles[0].documentTemplateFieldIds) {
        this.selectedFiles[0].documentTemplateFieldIds = [];
      }
      if(this.selectedFiles[0].parent.documentTemplateFieldIds && this.selectedFiles[0].parent.documentTemplateFieldIds.length > 0) {
        let linkedTemplateFields = this.linkedFields(this.selectedFiles[0].parent);
        if(linkedTemplateFields.length == 0) {
          this.selectedFiles[0].parent.documentTemplateFieldIds = [];
        } else {
          this.selectedFiles[0].documentTemplateFieldIds = [];
        }
      } else {
        this.selectedFiles[0].documentQuestionFieldValue= "";
      }
      this.previousBookmarkValue = this.selectedFiles[0].documentTemplateFieldIds;

    } else if (event.node.type.toLowerCase() == 'documentquestionsections') {
      id = event.node.DocumentQuestionSectionId

    } else if (event.node.type.toLowerCase() == 'documentquestions') {
      id = event.node.documentQuestionId

    }
    else if (event.node.type.toLowerCase() == 'documentquestionfields') {
      id = event.node.documentQuestionFieldId;
      if(this.selectedFiles[0].documentQuestionFieldDataTypeId) {
        this.checkDataType(false);
      } else {
        this.selectedFiles[0].showTemplateBookmark = true;
        this.dataTypeValue = "";
      }
      if(!this.selectedFiles[0].documentTemplateFieldIds) {
        this.selectedFiles[0].documentTemplateFieldIds = [];
      }
      this.previousBookmarkValue = this.selectedFiles[0].documentTemplateFieldIds;

    } else if(event.node.type.toLowerCase() == 'documentquestionfollowup') {
      try {
        if(this.selectedFiles[0].documentTemplateFieldIds && this.selectedFiles[0].documentTemplateFieldIds.length > 0) {
          this.selectedFiles[0].documentTemplateFieldIds.forEach(element => {
            if(this.selectedFiles[0].parent.documentTemplateFieldIds && this.selectedFiles[0].parent.documentTemplateFieldIds.length > 0) {
              let index = this.selectedFiles[0].parent.documentTemplateFieldIds.findIndex((item, index) => { return item == element });
              if (index != -1) {
                this.selectedFiles[0].parent.documentTemplateFieldIds.splice(index, 1);
              }
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
      if(this.selectedFiles[0].documentQuestionFieldDataTypeId) {
        this.checkDataType(false);
      } else {
        this.selectedFiles[0].showTemplateBookmark = true;
        this.dataTypeValue = "";
      }
      if(!this.selectedFiles[0].documentTemplateFieldIds) {
        this.selectedFiles[0].documentTemplateFieldIds = [];
      }
      this.previousBookmarkValue = this.selectedFiles[0].documentTemplateFieldIds;
    }
    else {
      id = event.node.documentTemplateId

    }
    this.type = event.node.type.toLowerCase();
    setTimeout(() => {
      if (this.content) {
        this.content.getScrollElement().then(el => {
          if (el) {
            this.content.scrollToPoint(0, 0, 0);
          }
        });
      }
      //this.inputElement.nativeElement.focus();
    }, 200);


    // else{
    //   id = event.node.documentQuestionFieldId

    // }

  }

  async onTemplateNodeSelect(event) {
    this.nodeSelected = true;
    this.bookmarkValue = event.node;
    if(this.bookmarkValue.documentQuestionTemplateFields.length == 0) {
      let obj = {
        documentQuestionId: null,
        documentQuestionFieldId: null,
        documentQuestionFieldValueId: null
      }
      this.bookmarkValue.documentQuestionTemplateFields.push(obj);
    }
    let tempValue = JSON.stringify(this.bookmarkValue.documentQuestionTemplateFields[0]);
    this.previousQuestionFields = JSON.parse(tempValue);
    let bookmarkType = this.dataType.find(x => x.DocumentBookmarkTypeId == this.bookmarkValue.documentBookmarkTypeId);
    if(bookmarkType)
    this.bookmarkValue.DocumentBookmarkTypeCode = bookmarkType.SystemTranslationCode;
    //this.documentQuestionFields = [];
    //this.documentQuestionFieldValues = [];
    // if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId) {
    //   this.getDocumentQuestionFields(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId);
    // }

    if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType && (this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_Companies" || this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_ContractCompanies" || this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_ContractPersons")) {
      this.dataTypeMappingList = [];
      let questionDatatype = this.questionFieldDataType.find(x => x.Code == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType);
      this.dataTypeMappingList = this.dataTypeMapping.filter(x => x.DocumentQuestionFieldDataTypeId == questionDatatype.DocumentQuestionFieldDataTypeId);
    } else {
      // if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId) {
      //   this.getDocumentQuestionFieldValues(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      // }
    }


    setTimeout(() => {
      if (this.content) {
        this.content.getScrollElement().then(el => {
          if (el) {
            this.content.scrollToPoint(0, 0, 0);
          }
        });
      }
    }, 100);
  }

  onDrop(event) {
    if (event.hasOwnProperty('dropIndex')) {
      if(event.dragNode.parent.type == event.dropNode.parent.type) {
        if(event.dropNode.parent.type == "DocumentTemplate") {
          this.QuestionList[0].isChildDropped = true;
        }

        if(event.dropNode.parent.type == "DocumentQuestionSections") {
          event.dragNode.documentQuestionSectionId = event.dropNode.documentQuestionSectionId;
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionsections');
          let parent = allNode.find(x => x.documentQuestionSectionId == event.dropNode.parent.documentQuestionSectionId);
          parent.isChildDropped = true;

        }
        if(event.dropNode.parent.type == "DocumentQuestions") {
          event.dragNode.documentQuestionId = event.dropNode.documentQuestionId;
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestions');
          let parent = allNode.find(x => x.documentQuestionId == event.dropNode.parent.documentQuestionId);
          parent.isChildDropped = true;
        }
        if(event.dropNode.parent.type == "DocumentQuestionFields") {
          event.dragNode.documentQuestionFieldId = event.dropNode.documentQuestionFieldId;
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionfields');
          let parent = allNode.find(x => x.documentQuestionFieldId == event.dropNode.parent.documentQuestionFieldId);
          parent.isChildDropped = true;
        }
        if (event.dropNode.parent.type == "DocumentQuestionFieldValues"){
          event.dragNode.documentQuestionFieldValueId = event.dropNode.documentQuestionFieldValueId;
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionfieldvalues');
          let parent = allNode.find(x => x.documentQuestionFieldValueId == event.dropNode.parent.documentQuestionFieldValueId);
          parent.isChildDropped = true;
        }
        if (event.dropNode.parent.type == "DocumentQuestionFollowup"){
          event.dragNode.documentQuestionFieldId = event.dropNode.documentQuestionFieldId;
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionfollowup');
          let parent = allNode.find(x => x.documentQuestionFieldId == event.dropNode.parent.documentQuestionFieldId);
          parent.isChildDropped = true;
        }

        event.accept()
      }
    } else {
      if(event.dragNode.type != event.dropNode.type) {
        if (event.dragNode.type == "DocumentQuestionSections"){

        }

        if (event.dragNode.type == "DocumentQuestions" && event.dropNode.type=="DocumentQuestionSections"){
          event.dragNode.documentQuestionSectionId = event.dropNode.documentQuestionSectionId;
          event.accept();
          this.dragNodeArray = [];
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionsections');
          let parent = allNode.find(x => x.documentQuestionSectionId == event.dragNode.documentQuestionSectionId);
          parent.isChildDropped = true;
        }

        if (event.dragNode.type == "DocumentQuestionFields" && event.dropNode.type=="DocumentQuestions"){
          event.dragNode.documentQuestionId = event.dropNode.documentQuestionId;
          event.accept();
          this.dragNodeArray = [];
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestions');
          let parent = allNode.find(x => x.documentQuestionId == event.dragNode.documentQuestionId);
          parent.isChildDropped = true
        }

        if (event.dragNode.type == "DocumentQuestionFieldValues"  && event.dropNode.type=="DocumentQuestionFields"){
          event.dragNode.documentQuestionFieldId = event.dropNode.documentQuestionFieldId;
          event.accept();
          this.dragNodeArray = [];
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionfields');
          let parent = allNode.find(x => x.documentQuestionFieldId == event.dragNode.documentQuestionFieldId);
          parent.isChildDropped = true;
        }

        if (event.dragNode.type == "DocumentQuestionFollowup"  && event.dropNode.type=="DocumentQuestionFieldValues"){
          event.dragNode.documentQuestionFieldValueId = event.dropNode.documentQuestionFieldValueId;
          event.accept();
          this.dragNodeArray = [];
          let allNode = this._commonService.findAll(this.QuestionList, 'documentquestionfieldvalues');
          let parent = allNode.find(x => x.documentQuestionFieldValueId == event.dragNode.documentQuestionFieldValueId);
          parent.isChildDropped = true;
        }
      }
    }
  }

  onTemplateNodeContextMenuSelect(event) {

  }

  onNodeContextMenuSelect(event) {
    this.selectedFiles = [];
    this.selectedFiles[0] = event.node;

    if (event.node.type.toLowerCase() == 'documenttemplate') {
      this.items = [
        { label: this._commonService.getLocalTranslation('label-addSection'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
      ];
    } else if (event.node.type.toLowerCase() == 'documentquestionsections') {
      this.items = [
        { label: this._commonService.getLocalTranslation('label-addQuestion'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
        { label: this._commonService.getLocalTranslation('label-deleteSection'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
      ];
    } else if (event.node.type.toLowerCase() == 'documentquestions') {
      this.items = [
        // { label: this._commonService.getLocalTranslation('label-addQuestionField'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
        { label: this._commonService.getLocalTranslation('label-addQuestionField'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
        { label: this._commonService.getLocalTranslation('label-deleteQuestion'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }

      ];
      //if (event.node.children.length == 0) {
      //  this.items.unshift({ label: this._commonService.getLocalTranslation('label-addQuestionField'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) })
      //}
    } else if (event.node.type.toLowerCase() == 'documentquestionfields') {
      this.items = [
        { label: this._commonService.getLocalTranslation('label-deleteQuestionField'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
      ];

      let dataType = '';
      if(event.node.documentQuestionFieldDataTypeId) {
        dataType = this.questionFieldDataType.find(dt => dt.DocumentQuestionFieldDataTypeId === event.node.documentQuestionFieldDataTypeId).Code;
      }
      if (dataType == 'DocQuestionFieldDataType_RadioGroup' || dataType == 'DocQuestionFieldDataType_SelectionList') {
        this.items.unshift({ label: this._commonService.getLocalTranslation('label-addQuestionFieldValue'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) })
      }
    } else if (event.node.type.toLowerCase() == 'documentquestionfieldvalues') {
      this.items = [
        { label: this._commonService.getLocalTranslation('label-addFollowupQuestion'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
        { label: this._commonService.getLocalTranslation('label-deleteQuestionFieldValue'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
      ];
    } else if (event.node.type.toLowerCase() == 'documentquestionfollowup') {
      this.items = [
        { label: this._commonService.getLocalTranslation('label-deleteFollowupQuestion'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
      ];

      let dataType = '';
      if(event.node.documentQuestionFieldDataTypeId) {
        dataType = this.questionFieldDataType.find(dt => dt.DocumentQuestionFieldDataTypeId === event.node.documentQuestionFieldDataTypeId).Code;
      }
      if (dataType == 'DocQuestionFieldDataType_RadioGroup' || dataType == 'DocQuestionFieldDataType_SelectionList') {
        this.items.unshift({ label: this._commonService.getLocalTranslation('label-addQuestionFieldValue'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) })
      }
    }

  }

  addNode(event) {
    let newNode = document.querySelector('.isNode-new');
    if (newNode) newNode.classList.remove("isNode-new");
    this.selectedFiles[0].isNodeNew = false;
    this.resetSelection(this.QuestionList, 'isNodeNew');
    if (this.selectedFiles[0].type.toLowerCase() == 'documenttemplate') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newSection'),
        "documentQuestionSectionId": uuid.v4(),
        "documentTemplateVersionId": this.selectedFiles[0].documentTemplateVersionId,
        "type": "DocumentQuestionSections",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "grid-outline",
        "collapsedIconDetail": "grid-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newSection') },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newSection') }
        ]
      }
      node["Description"] = node.label;
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestionsections';
      this.selectedFiles[0] = node;
      //this.onNodeSelect('');
      //this.onSubmit();

    } else if (this.selectedFiles[0].type.toLowerCase() == 'documentquestionsections') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newQuestion'),
        "documentQuestionId": uuid.v4(),
        "documentQuestionSectionId": this.selectedFiles[0].documentQuestionSectionId,
        "documentQuestionSupportId": null,
        "type": "DocumentQuestions",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "documents-outline",
        "collapsedIconDetail": "documents-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newQuestion'), descriptionSupport: '' },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newQuestion'), DescriptionSupport: '' }
        ]
      }
      node["Description"] = node.label;
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestions';
      this.selectedFiles[0] = node;

    } else if (this.selectedFiles[0].type.toLowerCase() == 'documentquestions') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newQuestionField'),
        "documentQuestionFieldId": uuid.v4(),
        "documentQuestionId": this.selectedFiles[0].documentQuestionId,
        "documentQuestionFieldDataTypeId": null,
        "documentTemplateFieldIds": [],
        "type": "DocumentQuestionFields",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "help-circle-outline",
        "collapsedIconDetail": "help-circle-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newQuestionField') },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newQuestionField') }
        ],
        "showTemplateBookmark": true,
        "documentTemplateFieldMapping": [

        ]
      }
      node["Description"] = node.label;
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestionfields';
      this.selectedFiles[0] = node;
      this.dataTypeValue = "";
      //this.onNodeSelect('');
      //this.onSubmit();

    } else if (this.selectedFiles[0].type.toLowerCase() == 'documentquestionfields') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newQuestionFieldValue'),
        "documentQuestionFieldValueId": uuid.v4(),
        "documentQuestionFieldId": this.selectedFiles[0].documentQuestionFieldId,
        "documentQuestionId": this.selectedFiles[0].documentQuestionId,
        "documentQuestionFieldValue": '',
        "documentTemplateFieldIds": [],
        "type": "DocumentQuestionFieldValues",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "chevron-forward-outline",
        "collapsedIconDetail": "chevron-forward-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newQuestionFieldValue') },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newQuestionFieldValue') }
        ]
      }
      node["Description"] = node.label;
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestionfieldvalues';
      this.selectedFiles[0] = node;
      //this.onNodeSelect('');
      //this.onSubmit();

    } else if (this.selectedFiles[0].type.toLowerCase() == 'documentquestionfieldvalues') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newFollowupQuestion'),
        "documentQuestionFieldValueId": this.selectedFiles[0].documentQuestionFieldValueId,
        "documentQuestionFieldId": uuid.v4(),
        "documentQuestionId": this.selectedFiles[0].parent.documentQuestionId,
        "documentQuestionFieldDataTypeId": null,
        "documentTemplateFieldIds": [],
        "type": "DocumentQuestionFollowup",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "help-circle-outline",
        "collapsedIconDetail": "help-circle-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newFollowupQuestion') },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newFollowupQuestion') }
        ]
      }
      node["Description"] = node.label;
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestionfollowup';
      this.selectedFiles[0] = node;
      //this.onNodeSelect('');
      //this.onSubmit();
      this.dataTypeValue = "";

    } else if (this.selectedFiles[0].type.toLowerCase() == 'documentquestionfollowup') {
      let node = {
        "label": this._commonService.getLocalTranslation('label-newQuestionFieldValue'),
        "documentQuestionFieldValueId": uuid.v4(),
        "documentQuestionFieldId": this.selectedFiles[0].documentQuestionFieldId,
        "documentQuestionFieldValue": '',
        "documentTemplateFieldIds": [],
        "type": "DocumentQuestionFieldValues",
        "expandedIcon": "fa fa-folder-open",
        "collapsedIcon": "fa fa-folder",
        "iconColor": "black",
        "textColor": "black",
        "isNodeNew": true,
        "expandedIconDetail": "chevron-forward-outline",
        "collapsedIconDetail": "chevron-forward-outline",
        "parent": this.selectedFiles[0],
        "isNodeEnabled": true,
        "newNode": true,
        "children": [],
        "translations": [
          { localeCode: "EN", localeId: 1033, description: this._commonService.getLocalTranslation('label-newQuestionFieldValue') },
          { localeCode: "NL", localeId: 1043, description: this._commonService.getLocalTranslation('label-newQuestionFieldValue') }
        ]
      }
      node["Description"] = node.label;
      if(!this.selectedFiles[0].children) {
        this.selectedFiles[0].children = [];
      }
      this.selectedFiles[0].children.push(node);
      this.selectedFiles[0].expanded = true;
      this.type = 'documentquestionfieldvalues';
      this.selectedFiles[0] = node;
      //this.onNodeSelect('');
      //this.onSubmit();

    }
  }

  deleteNode(event) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        let deletedNode = this.selectedFiles[0].parent.children.filter(n => n.label == this.selectedFiles[0].label)
        if (deletedNode[0].type.toLowerCase() === 'documentquestionsections') {
          this.deleteQuestionSection(deletedNode[0].documentQuestionSectionId)
        } else if (deletedNode[0].type.toLowerCase() === 'documentquestions') {
          this.deleteDocumentQuestion(deletedNode[0].documentQuestionId)
        } else if (deletedNode[0].type.toLowerCase() === 'documentquestionfields') {
          this.deleteQuestionFields(deletedNode[0].documentQuestionFieldId)
        } else if (deletedNode[0].type.toLowerCase() === 'documentquestionfieldvalues') {
          this.deleteQuestionFieldValues(deletedNode[0].documentQuestionFieldValueId)
        } else if (deletedNode[0].type.toLowerCase() === 'documentquestionfollowup') {
          this.deleteQuestionFields(deletedNode[0].documentQuestionFieldId)
        }
      })
  }

  async deleteQuestionSection(id) {
    try {
      let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.documentQuestionSectionId == this.selectedFiles[0].documentQuestionSectionId});
      this._commonService.presentLoading();
      await this._apiService.deleteDocumentQuestionSections(id);
      this.selectedFiles[0].parent.children.splice(index, 1);
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async deleteDocumentQuestion(id) {
    try {
      let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.documentQuestionId == this.selectedFiles[0].documentQuestionId});
      this._commonService.presentLoading();
      await this._apiService.deleteDocumentQuestions(id);
      this.selectedFiles[0].parent.children.splice(index, 1);
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async deleteQuestionFields(id) {
    try {
      let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.documentQuestionFieldId == this.selectedFiles[0].documentQuestionFieldId});
      this._commonService.presentLoading();
      await this._apiService.deleteDocumentQuestionsFields(id);
      this.selectedFiles[0].parent.children.splice(index, 1);
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async deleteQuestionFieldValues(id) {
    try {
      let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.documentQuestionFieldValueId == this.selectedFiles[0].documentQuestionFieldValueId});
      this._commonService.presentLoading();
      await this._apiService.deleteDocumentQuestionFieldValue(id);
      this.selectedFiles[0].parent.children.splice(index, 1);
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async onSubmit() {
    if (this.category == 'algemeen') {
      this.submitted = true;
      let ext;
      ext = this.versionForm.value.DocumentName.split('.').pop();
      if (ext != 'docx' || ext == '' || ext == null) {
        this.versionForm.controls['DocumentName'].setErrors({ 'incorrect': true });
      }

      if (this.versionForm.invalid) {
        this._commonService.scrollToError();
        return;
      }

      this._commonService.presentLoading();
      try {
        this.vesionData.FileName = this.versionForm.value.DocumentName;
        this.vesionData.VersionNumber = this.versionForm.value.Version;
        this.vesionData.IsArchive = Number(this.versionForm.value.Archive) ? "1" : "0";
        let res = await this._apiService.postVersionDetails(this.vesionData);
        this.saveDocumentQuestionSections();
        this._commonService.log(this.templateId, this._commonService.LOG);
        this._commonService.dismiss();
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        this.submitted = false;
        this.getVersionDetails();
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    } else {
      this.vesionData.FileName = this.versionForm.value.DocumentName;
      this.vesionData.VersionNumber = this.versionForm.value.Version;
      this.vesionData.IsArchive = Number(this.versionForm.value.Archive) ? "1" : "0";
      this._apiService.postVersionDetails(this.vesionData);
      this.saveDocumentQuestionSections();
    }

  }

  changeLocale() {
    for (var i = 0; i < this.QuestionList[0].children.length; i++) {
      let section = this.QuestionList[0].children[i];
      let label = section.translations.filter(x => x.localeId == this.locale);
      if (label.length > 0) {
        section.label = label[0].description;
      }
      for (var j = 0; j < section.children.length; j++) {
        let question = section.children[j];
        let label = question.translations ? question.translations.filter(x => x.localeId == this.locale) : [];
        if (label.length > 0) {
          question.label = label[0].description;
          question.descriptionSupport = label[0].descriptionSupport;
        }
        for (var k = 0; k < question.children.length; k++) {
          let questionField = question.children[k];
          let label = questionField.translations ? questionField.translations.filter(x => x.localeId == this.locale) : [];
          if (label.length > 0) {
            questionField.label = label[0].description;
          }
          for (var l = 0; l < questionField.children.length; l++) {
            let questionFieldValue = questionField.children[l];
            let label = questionFieldValue.translations ? questionFieldValue.translations.filter(x => x.localeId == this.locale) : [];
            if (label.length > 0) {
              questionFieldValue.label = label[0].description;
            }
            for (var m = 0; m < questionFieldValue.children.length; m++) {
              let questionFollowup = questionFieldValue.children[m];
              let label = questionFollowup.translations ? questionFollowup.translations.filter(x => x.localeId == this.locale) : [];
              if (label.length > 0) {
                questionFollowup.label = label[0].description;
              }
            }
          }
        }
      }
    }
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      header: this._commonService.getLocalTranslation('label-alert'),
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }

  async saveDocumentQuestionSections() {
    this.submitted = true;
    this.arraydocumentquestionsections = [];
    this.arraydocumentquestions = [];
    this.arraydocumentquestionfields = [];
    this.arraydocumentquestionfieldvalues = [];
    this.arraydocumentquestionfieldfollowup = [];
    let emptyDescription  = this.findFilter(this.QuestionList, '');
    if(emptyDescription.length > 0) {
      this.selectedFiles[0] = emptyDescription[0];
      this.type = this.selectedFiles[0].type.toLowerCase();
      // setTimeout(() => {
      //   this.inputElement.nativeElement.focus();
      // }, 200);
      return;
    }
    try {
      let allSections = this._commonService.findAll(this.QuestionList, 'documentquestionsections');
      let allQuestions = this._commonService.findAll(this.QuestionList, 'documentquestions');
      let allFields = this._commonService.findAll(this.QuestionList, 'documentquestionfields');
      let allFieldValues = this._commonService.findAll(this.QuestionList, 'documentquestionfieldvalues');
      let allFollowUps = this._commonService.findAll(this.QuestionList, 'documentquestionfollowup');

      for(var i=0; i< allSections.length;i++) {
        let documentSection = allSections[i];
        if(documentSection.isModified || this.QuestionList[0].isChildDropped || documentSection.newNode) {
          let data = {
            DocumentQuestionSectionId: documentSection.documentQuestionSectionId ? documentSection.documentQuestionSectionId : null,
            DocumentTemplateVersionId: this.versionId ? this.versionId : null,
            Translations: [
              {LocaleId: 1033, LocaleCode: 'EN', Description: documentSection.translations[0].description},
              {LocaleId: 1043, LocaleCode: 'NL', Description: documentSection.translations[0].description}
            ],
            SortOrder: i+1
          }
          this.arraydocumentquestionsections.push(data);
        }
      }

      for (var j = 0; j < allQuestions.length; j++) {
        let documentQuestion = allQuestions[j];
        let parent = allSections.find(x => x.documentQuestionSectionId == documentQuestion.documentQuestionSectionId);
        let index = parent ? parent.children.findIndex((item, index) => {return item.documentQuestionId == documentQuestion.documentQuestionId}) : null;
        if (documentQuestion.isModified || (parent && parent.isChildDropped) || documentQuestion.newNode) {
          let data = {
            DocumentQuestionSectionId: documentQuestion.documentQuestionSectionId ? documentQuestion.documentQuestionSectionId : null,
            DocumentQuestionId: documentQuestion.documentQuestionId ? documentQuestion.documentQuestionId : null,
            DocumentQuestionSupportId: documentQuestion.documentQuestionSupportId,
            Translations: [
              { LocaleId: 1033, LocaleCode: 'EN', Description: documentQuestion.translations[0].description, DescriptionSupport: documentQuestion.translations[0].descriptionSupport },
              { LocaleId: 1043, LocaleCode: 'NL', Description: documentQuestion.translations[0].description, DescriptionSupport: documentQuestion.translations[0].descriptionSupport }
            ],
            SortOrder: index
          }
          this.arraydocumentquestions.push(data);
        }
      }

      for (var k = 0; k < allFields.length; k++) {
        let documentQuestionField = allFields[k];
        let parent = allQuestions.find(x => x.documentQuestionId == documentQuestionField.documentQuestionId);
        let index = parent ? parent.children.findIndex((item, index) => {return item.documentQuestionFieldId == documentQuestionField.documentQuestionFieldId}) : null;
        let datatype = '';
        if (documentQuestionField.documentQuestionFieldDataTypeId) {
          datatype = this.questionFieldDataType.find(dt => dt.DocumentQuestionFieldDataTypeId === documentQuestionField.documentQuestionFieldDataTypeId).Code;
        }
        if ((datatype == 'DocQuestionFieldDataType_RadioGroup' || datatype == 'DocQuestionFieldDataType_SelectionList') && documentQuestionField.children.length < 1) {
          let msg = this._commonService.getLocalTranslation('label-minimumOneAnswerRequiredIn') + ' : <br>' + documentQuestionField.label;
          this.presentAlert(msg);
          return;
        }

        if(documentQuestionField.isModified || (parent && parent.isChildDropped) || documentQuestionField.newNode) {
          let data = {
            DocumentQuestionFieldId: documentQuestionField.documentQuestionFieldId ? documentQuestionField.documentQuestionFieldId : null,
            DocumentQuestionId: documentQuestionField.documentQuestionId ? documentQuestionField.documentQuestionId : null,
            DocumentQuestionFieldDataTypeId: documentQuestionField.documentQuestionFieldDataTypeId ? documentQuestionField.documentQuestionFieldDataTypeId : null,
            DocumentTemplateFieldIds: documentQuestionField.documentTemplateFieldIds,
            DocumentTemplateFieldMapping: [],
            Translations: [
              { LocaleId: 1033, LocaleCode: 'EN', Description: documentQuestionField.translations[0].description },
              { LocaleId: 1043, LocaleCode: 'NL', Description: documentQuestionField.translations[0].description }
            ],
            SortOrder: index

          }
          if (documentQuestionField.documentTemplateFieldMapping && documentQuestionField.documentTemplateFieldMapping.length > 0) {
            documentQuestionField.documentTemplateFieldMapping.forEach(element => {
              var obj = {
                DocumentQuestionTemplateFieldId: element.documentQuestionTemplateFieldId,
                DocumentQuestionDataTypeMappingId: element.documentQuestionDataTypeMappingId,
                DocumentTemplateFieldId: element.documentTemplateFieldId
              }
              data.DocumentTemplateFieldMapping.push(obj);
            });
          }
          this.arraydocumentquestionfields.push(data);
        }
      }

      for (var l = 0; l < allFieldValues.length; l++) {
        let documentQuestionFieldValue = allFieldValues[l];
        let parent;
        if(documentQuestionFieldValue.parent && documentQuestionFieldValue.parent.type.toLowerCase() == "documentquestionfields") {
          parent = allFields.find(x => x.documentQuestionFieldId == documentQuestionFieldValue.documentQuestionFieldId);
        } else {
          parent = allFollowUps.find(x => x.documentQuestionFieldId == documentQuestionFieldValue.documentQuestionFieldId);
        }

        let index = parent ? parent.children.findIndex((item, index) => {return item.documentQuestionFieldValueId == documentQuestionFieldValue.documentQuestionFieldValueId}): null;
        if(documentQuestionFieldValue.isModified || (parent && parent.isChildDropped) || documentQuestionFieldValue.newNode) {
          let data = {
            DocumentQuestionFieldId: documentQuestionFieldValue.documentQuestionFieldId ? documentQuestionFieldValue.documentQuestionFieldId : null,
            DocumentQuestionFieldValueId: documentQuestionFieldValue.documentQuestionFieldValueId ? documentQuestionFieldValue.documentQuestionFieldValueId : null,
            DocumentQuestionFieldValue: documentQuestionFieldValue.documentQuestionFieldValue,
            DocumentTemplateFieldIds: documentQuestionFieldValue.documentTemplateFieldIds,
            Translations: [
              { LocaleId: 1033, LocaleCode: 'EN', Description: documentQuestionFieldValue.translations[0].description },
              { LocaleId: 1043, LocaleCode: 'NL', Description: documentQuestionFieldValue.translations[0].description }
            ],
            SortOrder: index
          }
          this.arraydocumentquestionfieldvalues.push(data);
        }
      }

      for (var m = 0; m < allFollowUps.length; m++) {
        let documentQuestionFieldValueFollowup = allFollowUps[m];
        let parent = allFieldValues.find(x => x.documentQuestionFieldValueId == documentQuestionFieldValueFollowup.documentQuestionFieldValueId);
        let index = parent ? parent.children.findIndex((item, index) => {return item.documentQuestionFieldId == documentQuestionFieldValueFollowup.documentQuestionFieldId}) : null;
        let datatype = '';
        if (documentQuestionFieldValueFollowup.documentQuestionFieldDataTypeId) {
          datatype = this.questionFieldDataType.find(dt => dt.DocumentQuestionFieldDataTypeId === documentQuestionFieldValueFollowup.documentQuestionFieldDataTypeId).Code;
        }
        if ((datatype == 'DocQuestionFieldDataType_RadioGroup' || datatype == 'DocQuestionFieldDataType_SelectionList') && (!documentQuestionFieldValueFollowup.children || (documentQuestionFieldValueFollowup.children && documentQuestionFieldValueFollowup.children.length < 1))) {
          let msg = this._commonService.getLocalTranslation('label-minimumOneAnswerRequiredIn') + ' : <br>' + documentQuestionFieldValueFollowup.label;
          this.presentAlert(msg);
          return;
        }


        if (documentQuestionFieldValueFollowup.isModified || (parent && parent.isChildDropped) || documentQuestionFieldValueFollowup.newNode) {
          let questionId;
          let parentQuestion;
          try {
            let questions = this._commonService.findAll(this.QuestionList, 'documentquestions');
            let fields = this._commonService.findAll(this.QuestionList, 'documentquestionfields').concat(this._commonService.findAll(this.QuestionList, 'documentquestionfollowup'));
            if(parent.type.toLowerCase() == "documentquestionfieldvalues") {
              let parentField = fields.find(x => x.documentQuestionFieldId == parent.documentQuestionFieldId);
              parentQuestion = questions.find(x => x.documentQuestionId == parentField.documentQuestionId);
            } else if(parent.type.toLowerCase() == "documentquestionfields") {
              parentQuestion = questions.find(x => x.documentQuestionId == parent.documentQuestionId);
            }
            questionId = parentQuestion.documentQuestionId;
          } catch (error) {
            questionId = null;
            console.log(error);
          }
          let data = {
            DocumentQuestionFieldId: documentQuestionFieldValueFollowup.documentQuestionFieldId ? documentQuestionFieldValueFollowup.documentQuestionFieldId : null,
            DocumentQuestionId: questionId ? questionId : null,
            DocumentQuestionFieldValueId: documentQuestionFieldValueFollowup.documentQuestionFieldValueId ? documentQuestionFieldValueFollowup.documentQuestionFieldValueId : null,
            DocumentQuestionFieldDataTypeId: documentQuestionFieldValueFollowup.documentQuestionFieldDataTypeId ? documentQuestionFieldValueFollowup.documentQuestionFieldDataTypeId : null,
            DocumentTemplateFieldIds: documentQuestionFieldValueFollowup.documentTemplateFieldIds,
            DocumentTemplateFieldMapping: [],
            Translations: [
              { LocaleId: 1033, LocaleCode: 'EN', Description: documentQuestionFieldValueFollowup.translations[0].description },
              { LocaleId: 1043, LocaleCode: 'NL', Description: documentQuestionFieldValueFollowup.translations[0].description }
            ],
            SortOrder: index
          }

          if (documentQuestionFieldValueFollowup.documentTemplateFieldMapping && documentQuestionFieldValueFollowup.documentTemplateFieldMapping.length > 0) {
            documentQuestionFieldValueFollowup.documentTemplateFieldMapping.forEach(element => {
              var obj = {
                DocumentQuestionTemplateFieldId: element.documentQuestionTemplateFieldId,
                DocumentQuestionDataTypeMappingId: element.documentQuestionDataTypeMappingId,
                DocumentTemplateFieldId: element.documentTemplateFieldId
              }
              data.DocumentTemplateFieldMapping.push(obj);
            });
          }

          this.arraydocumentquestionfieldfollowup.push(data);
        }
      }

      this._commonService.presentLoading();
      if(this.arraydocumentquestionsections.length > 0) {
        let sectionRequest = await this._apiService.postDocumentQuestionSections(this.arraydocumentquestionsections);
      }

      if(this.arraydocumentquestions.length > 0) {
        let questionRequest = await  this._apiService.postDocumentQuestion(this.arraydocumentquestions);
      }

      if(this.arraydocumentquestionfields.length > 0) {
        let answerRequest = await  this._apiService.postDocumentQuestionFields(this.arraydocumentquestionfields);
      }

      if(this.arraydocumentquestionfieldvalues.length > 0) {
        let answerRequest = await  this._apiService.postDocumentQuestionFieldValue(this.arraydocumentquestionfieldvalues);
      }

      if(this.arraydocumentquestionfieldfollowup.length > 0) {
        let answerRequest = await  this._apiService.postDocumentQuestionFields(this.arraydocumentquestionfieldfollowup);
      }
      //this.getTemplateDetails();
      this.getVersionDetails();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.dismiss();
      return true;
    } catch (error) {
      this._commonService.dismiss();
      console.log(error);
      return false;
    }
  }

  async openWizard() {
    this.vesionData.FileName = this.versionForm.value.DocumentName;
    this.vesionData.VersionNumber = this.versionForm.value.Version;
    this.vesionData.IsArchive = Number(this.versionForm.value.Archive) ? "1" : "0";
    this._apiService.postVersionDetails(this.vesionData);
    await this.saveDocumentQuestionSections();
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/documentgenerator/wizard/${this.templateId}/${this.versionId}`])
    );
    window.open(url, '_blank');
  }

  get f() { return this.versionForm.controls; }

  goBack() {
    this.location.back();
  }

  goBackList() {
    this.router.navigate(['maintenance/documentgenerator'], { replaceUrl: true })
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        // this.delete();
        break;
      case "backToList":
        this.goBackList();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
      case "backToMainTitle":
        this.goBack();
        break;
      case "download":
        this.downloadTemplate();
      case "upload":
      // this.uploadTemplate();


    }

  }

  async downloadTemplate() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getDownloadDocument(this.versionId);
      var blob = new Blob([res.body], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const fileName = res.headers.get('X-Blob-FileName');

      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);;
      downloadLink.download = fileName;
      downloadLink.click();
      this._commonService.dismiss();
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async updateBookmark() {
      try {
        let bookmarkType = this.dataType.find(x=> x.DocumentBookmarkTypeId == this.bookmarkValue.documentBookmarkTypeId);
        if(bookmarkType && bookmarkType.SystemTranslationCode == 'DocTempDataType_Replacement') {
          if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId) {
            this.bookmarkValue.iconColor = 'green';
          } else {
            this.bookmarkValue.iconColor = 'red';
          }
        } else if (bookmarkType && bookmarkType.SystemTranslationCode == 'DocBookmarkType_Parent') {
          if(this.bookmarkValue.children && this.bookmarkValue.children.find(x => x.iconColor == "red")) {
            this.bookmarkValue.iconColor = 'red';
          } else {
            this.bookmarkValue.iconColor = 'green';
          }
        }
        let data = [{
            DocumentTemplateVersionId : this.versionId,
            DocumentBookmarkTypeId : this.bookmarkValue.documentBookmarkTypeId,
            DocumentTemplateFieldId : this.bookmarkValue.documentTemplateFieldId
          }]
        let res = await this._apiService.putDocumentBookmark(this.versionId, data);

        let response = await this._apiService.getDocumentTemplateFieldList(this.versionId);
        this.documentTemplateFieldList = response.body;
      } catch (error) {
        this._commonService.log(error, this._commonService.ERROR);
      }
  }

  updateDescription() {
    this.selectedFiles[0].isModified = true;
    if(!this.selectedFiles[0].translations) {
      this.selectedFiles[0].translations = [
        { localeCode: "EN", localeId: 1033, description: '' },
        { localeCode: "NL", localeId: 1043, description: '' }
      ]
    }
    this.selectedFiles[0].translations.forEach(label => {
      if(this.selectedFiles[0].label) {
        label.description = this.selectedFiles[0].label;
      }

      if(this.selectedFiles[0].descriptionSupport || this.selectedFiles[0].descriptionSupport=='' ) {
        label.descriptionSupport = this.selectedFiles[0].descriptionSupport;
      }
    });
  }

  updateChild() {
      this.selectedFiles[0].isChildDropped = true;
        if(this.selectedFiles[0].children && this.selectedFiles[0].children.length > 0) {
          this.selectedFiles[0].children.forEach(element => {
            if(this.selectedFiles[0].documentTemplateFieldIds && this.selectedFiles[0].documentTemplateFieldIds.length > 0) {
              element.documentTemplateFieldIds = [];
            } else {
              element.documentQuestionFieldValue= "";
            }
          });
        }
  }

  checkDataType(optionChanged) {

    let dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId  == this.selectedFiles[0].documentQuestionFieldDataTypeId);
    if(dataType) {
      if(dataType.Code != 'DocQuestionFieldDataType_RadioGroup' && dataType.Code != 'DocQuestionFieldDataType_SelectionList') {
        this.selectedFiles[0].children = [];
      }
      if(dataType.Code == 'DocQuestionFieldDataType_Companies' || dataType.Code == 'DocQuestionFieldDataType_ContractPersons' || dataType.Code == 'DocQuestionFieldDataType_ContractCompanies') {
        if(optionChanged) {
          this.selectedFiles[0].documentTemplateFieldMapping = [];
          this.selectedFiles[0].documentTemplateFieldIds = [];
        }
        this.dataTypeValue = dataType.Code;
      } else {
        this.dataTypeValue = dataType.Code;
      }
      if(dataType.Code != 'DocQuestionFieldDataType_Companies' && dataType.Code != 'DocQuestionFieldDataType_ContractPersons' && dataType.Code != 'DocQuestionFieldDataType_ContractCompanies') {
        this.selectedFiles[0].showTemplateBookmark = true;
      } else {
        this.selectedFiles[0].showTemplateBookmark = false;
      }
    } else {
      this.dataTypeValue = "";
      this.selectedFiles[0].showTemplateBookmark = true;
    }

  }

  addTemplateBookmark() {
    if(this.selectedFiles[0].documentTemplateFieldMapping && this.selectedFiles[0].documentTemplateFieldMapping.length > 0) {
      this.selectedFiles[0].documentTemplateFieldMapping.forEach(element => {
        element.editable = false;
      });
    }
    var obj = {
      documentQuestionTemplateFieldId: uuid.v4(),
      documentQuestionDataTypeMappingId: null,
      documentTemplateFieldId: null,
      editable: true
    }
    if(!this.selectedFiles[0].documentTemplateFieldMapping) {
      this.selectedFiles[0].documentTemplateFieldMapping = [];
    }
    this.selectedFiles[0].documentTemplateFieldMapping.push(obj);
  }

  setActive(item) {
    this.selectedFiles[0].documentTemplateFieldMapping.forEach(element => {
      element.editable = false;
    });
    item.editable = true;
  }

  deleteTemplateBookmark(element) {
    let index = this.selectedFiles[0].documentTemplateFieldMapping.findIndex((item, index) => {return item.documentQuestionTemplateFieldId == element.documentQuestionTemplateFieldId});
    this.selectedFiles[0].documentTemplateFieldMapping.splice(index, 1);
    if(this.selectedFiles[0].documentTemplateFieldIds.length > 0) {
      let index = this.selectedFiles[0].documentTemplateFieldIds.findIndex((item, index) => {return item == element.documentTemplateFieldId});
      if(index != -1) {
        this.selectedFiles[0].documentTemplateFieldIds.splice(index, 1);
      }
    }
    let bookmark = this.filterArray(this.templateFieldList, 'documentTemplateFieldId', element.documentTemplateFieldId);
    if(bookmark && bookmark.length > 0) {
      if(bookmark[0].documentQuestionTemplateFields && bookmark[0].documentQuestionTemplateFields.length > 0) {
        bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldId = null;
        bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldValueId = null;
        bookmark[0].documentQuestionTemplateFields[0].documentQuestionId = null;
        bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldDataType = null;
        bookmark[0].iconColor = 'red';
        this.updateParentNode(bookmark[0]);
      } else {
        let obj = {
          documentQuestionFieldId: null,
          documentQuestionFieldValueId: null,
          documentQuestionId: null,
          documentQuestionFieldDataType: null
        }
        bookmark[0].documentQuestionTemplateFields.push(obj);
        bookmark[0].iconColor = 'red';
        this.updateParentNode(bookmark[0]);
      }
    }
  }

  get documentQuestions() {
    return this._commonService.findAll(this.QuestionList, 'documentquestions');
  }

  get documentQuestionFields() {
    if(this.bookmarkValue.documentQuestionTemplateFields[0] && this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId){
      let list = this._commonService.findAll(this.QuestionList, 'documentquestions').find(x => x.documentQuestionId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId);
      let questions = list ? list.children ? list.children : [] : [];
      let questionFollowUp = this._commonService.findAll(questions, 'documentquestionfollowup')
      let allQuestion = questions.concat(questionFollowUp);
      return allQuestion.sort((a, b) => {
        if (a.label.toLowerCase().trim() > b.label.toLowerCase().trim()) {
          return 1;
      }
      if (a.label.toLowerCase().trim() < b.label.toLowerCase().trim()) {
          return -1;
      }
      return 0;
      });
    } else {
      return [];
    }
  }

  get documentQuestionFieldValues() {
    if(this.bookmarkValue.documentQuestionTemplateFields[0] && this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId){
      let documentQuestion = this._commonService.findAll(this.QuestionList, 'documentquestionfields').find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      let documentQuestionFollowUp = this._commonService.findAll(this.QuestionList, 'documentquestionfollowup').find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      let allQuestion;
      if(documentQuestion && documentQuestionFollowUp) {
        allQuestion = documentQuestion.children.concat(documentQuestionFollowUp.children);
      } else if(documentQuestion && !documentQuestionFollowUp){
        allQuestion = documentQuestion.children
      } else if(!documentQuestion && documentQuestionFollowUp){
        allQuestion = documentQuestionFollowUp.children;
      }

      if(allQuestion) {
        return allQuestion.sort((a, b) => {
          if (a.label.toLowerCase().trim() > b.label.toLowerCase().trim()) {
            return 1;
        }
        if (a.label.toLowerCase().trim() < b.label.toLowerCase().trim()) {
            return -1;
        }
        return 0;
        });
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  filteredFields() {
    let docTemplates = this.getLinkedDocumentTemplates();
    let result = [];
    this.documentTemplateFieldList.forEach(x => {
      if(x.DocumentBookmarkType && x.DocumentBookmarkType.indexOf('_Replacement') != -1) {
        if(x.DocumentBookmarkName.toLowerCase().includes(this.searchDocumentBookmarkName.toLowerCase()) && (!docTemplates.includes(x.DocumentTemplateFieldId))) {
          result.push(x);
        }
        if(this.selectedFiles[0].documentTemplateFieldIds && this.selectedFiles[0].documentTemplateFieldIds.length > 0) {
          this.selectedFiles[0].documentTemplateFieldIds.forEach(element => {
            if(element == x.DocumentTemplateFieldId) {
              result.push(x);
            }
          });
        }
      }
    });
    return result;
  }

  optionalTemplateBookmark() {
    let docTemplates = this.getLinkedDocumentTemplates();
    let result = [];
    this.documentTemplateFieldList.forEach(x => {
      if(x.DocumentBookmarkType && x.DocumentBookmarkType.indexOf('_Optional') != -1) {
        if(x.DocumentBookmarkName.toLowerCase().includes(this.searchDocumentBookmarkName.toLowerCase()) && (!docTemplates.includes(x.DocumentTemplateFieldId))) {
          result.push(x);
        }
        if(this.selectedFiles[0].documentTemplateFieldIds && this.selectedFiles[0].documentTemplateFieldIds.length > 0) {
          this.selectedFiles[0].documentTemplateFieldIds.forEach(element => {
            if(element == x.DocumentTemplateFieldId) {
              result.push(x);
            }
          });
        }
      }
    });
    return result;
  }

  getLinkedDocumentTemplates() {
    let nodeWithDocumentTemplate = this._commonService.findAll(this.QuestionList, 'documentquestionfields').concat(this._commonService.findAll(this.QuestionList, 'documentquestionfollowup')).concat(this._commonService.findAll(this.QuestionList, 'documentquestionfieldvalues'));
    let nodeWithMapping = nodeWithDocumentTemplate.filter(x => x.documentTemplateFieldMapping);
    let mappingdocumentTemplates = [];
    let mappingNodeMapping = [];
    if(nodeWithDocumentTemplate) {
      mappingdocumentTemplates = Array.prototype.concat.apply([], nodeWithDocumentTemplate.map(x=> x.documentTemplateFieldIds));
    }
    if(nodeWithMapping && nodeWithMapping.length > 0) {
      nodeWithMapping.forEach(element => {
        let list = element.documentTemplateFieldMapping.map(z => z.documentTemplateFieldId);
        mappingNodeMapping = mappingNodeMapping.concat(list);
      });
    }
    mappingNodeMapping.forEach(element => {
      if(!mappingdocumentTemplates.includes(element)) {
        mappingdocumentTemplates.push(element);
      }
    });
    return mappingdocumentTemplates;
  }

  get replacementDataType() {
    return this.questionFieldDataType.filter(x => x.Code != 'DocQuestionFieldDataType_RadioGroup' && x.Code != 'DocQuestionFieldDataType_SelectionList' && x.Code != 'DocQuestionFieldDataType_Companies' && x.Code != 'DocQuestionFieldDataType_ContractCompanies' && x.Code != 'DocQuestionFieldDataType_ContractPersons')
  }

  get filterDataType() {
    if(this.bookmarkValue.DocumentBookmarkTypeCode == "DocTempDataType_Optional") {
      return this.dataType;
    } else {
      return this.dataType.filter(x => x.SystemTranslationCode != 'DocTempDataType_Optional');
    }

  }

  resetSelection(arr, key) {
    arr.forEach(i => {
      if(i[key]) {
        i[key] = false;
      }
      if (i.children && i.children.length > 0) {
        this.resetSelection(i.children, key);
      }
    })
  }

  get filterDataTypeMapping() {
    return this.dataTypeMapping.filter(x => x.DocumentQuestionFieldDataTypeId == this.selectedFiles[0].documentQuestionFieldDataTypeId  && x.translatedDescription.toLowerCase().includes(this.searchDescription.toLowerCase()))
  }

  filterTemplateFieldList(id) {
    let docTemplates = this.getLinkedDocumentTemplates();
    let result = [];
    this.documentTemplateFieldList.forEach(x => {
      if((x.DocumentBookmarkName.toLowerCase().includes(this.searchDocumentBookmarkName.toLowerCase()) && (!docTemplates.includes(x.DocumentTemplateFieldId))) || (id && x.DocumentTemplateFieldId == id)) {
        result.push(x);
      }
    });
    return result;
    //return this.documentTemplateFieldList.filter(x => x.DocumentBookmarkName.toLowerCase().includes(this.searchDocumentBookmarkName.toLowerCase()))
  }

  updateValue(control) {
    if(control == 'question') {
      this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId = null;
      this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId = null;
    }
    if(control == 'questionField') {
      this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId = null;
      let questionField = this.documentQuestionFields.find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      if(questionField) {
        if(!questionField.Code) {
          let dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId == questionField.documentQuestionFieldDataTypeId);
          questionField.Code = dataType ? dataType.Code : null;
        }
        this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType = questionField.Code;
      }
      if(questionField && (questionField.Code == "DocQuestionFieldDataType_Companies" || questionField.Code == "DocQuestionFieldDataType_ContractCompanies" || questionField.Code == "DocQuestionFieldDataType_ContractPersons")) {
        this.dataTypeMappingList = [];
        let questionDatatype = this.questionFieldDataType.find(x => x.Code == questionField.Code);
        this.dataTypeMappingList = this.dataTypeMapping.filter(x => x.DocumentQuestionFieldDataTypeId == questionDatatype.DocumentQuestionFieldDataTypeId);
      }
    }
    let obj = {
      DocumentTemplateFieldId: this.bookmarkValue.documentTemplateFieldId,
      DocumentQuestionTemplateFieldId: this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionTemplateFieldId,
      DocumentQuestionId: this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionId,
      DocumentQuestionFieldId: this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId,
      DocumentBookmarkTypeId: this.bookmarkValue.documentBookmarkTypeId
    }
    if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType && (this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_Companies" || this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_ContractCompanies" || this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldDataType == "DocQuestionFieldDataType_ContractPersons")) {
      obj['DocumentQuestionDataTypeMappingId'] = this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId;
    } else {
      obj['DocumentQuestionFieldValueId'] = this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId;
    }
    if(this.bookmarkTemplateFields.length == 0) {
      this.bookmarkTemplateFields.push(obj);
    } else {
      var index = this.bookmarkTemplateFields.findIndex((item, index) => {return item.DocumentTemplateFieldId  == this.bookmarkValue.documentTemplateFieldId});
      if(index == -1 ){
        this.bookmarkTemplateFields.push(obj);
      } else {
        this.bookmarkTemplateFields[index] = obj;
      }
    }
    if(this.bookmarkValue.DocumentBookmarkTypeCode == 'DocTempDataType_Optional') {
      if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId){
        this.bookmarkValue.iconColor = 'green';
      } else {
        this.bookmarkValue.iconColor = 'red';
      }
    } else if(this.bookmarkValue.DocumentBookmarkTypeCode == 'DocTempDataType_Replacement') {
      let questionFields = this._commonService.findAll(this.QuestionList, 'documentquestionfields').concat(this._commonService.findAll(this.QuestionList, 'documentquestionfollowup'));
      let dataType;
      try {
        if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId) {
          let field = questionFields.find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
          dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId == field.documentQuestionFieldDataTypeId);
        }
      } catch (error) {
        console.log(error);
        dataType = null;
      }
      if(dataType && (dataType.Code == "DocQuestionFieldDataType_Companies" || dataType.Code == "DocQuestionFieldDataType_ContractCompanies" || dataType.Code == "DocQuestionFieldDataType_ContractPersons")) {
        if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId){
          this.bookmarkValue.iconColor = 'green';
        } else {
          this.bookmarkValue.iconColor = 'red';
        }
      } else {
        if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId){
          this.bookmarkValue.iconColor = 'green';
        } else {
          this.bookmarkValue.iconColor = 'red';
        }
      }
    }
    let bookmarktype = this.dataType.filter(x=> x.DocumentBookmarkTypeId == this.bookmarkValue.documentBookmarkTypeId)[0];
    this.bookmarkValue.DocumentBookmarkType = bookmarktype ? bookmarktype.Description : '';
    this.updateParentNode(this.selectedTemplateFiles[0]);
    this.updateQuestionField();
  }

  updateParentNode(obj) {
    //arr.forEach(element => {
        if(obj.parent && obj.parent.children && obj.parent.children.length > 0) {
          let datatype = this.dataType.find(x => x.DocumentBookmarkTypeId == obj.parent.documentBookmarkTypeId);
          if(datatype && datatype.SystemTranslationCode == "DocBookmarkType_Parent") {
            let item = obj.parent.children.filter(x => x.iconColor == 'red');
            if(item.length == 0) {
              obj.parent.iconColor = 'green';
            } else {
              obj.parent.iconColor = 'red';
            }
          }

          //this.updateParentNode(obj.parent);
        }


    //})
  }

  updateQuestionField() {
    if(this.previousQuestionFields && this.previousQuestionFields.documentQuestionFieldId) {
      //remove previous link
      let questionField = this._commonService.findAll(this.QuestionList, 'documentquestionfields').find(x => x.documentQuestionFieldId == this.previousQuestionFields.documentQuestionFieldId) ? this._commonService.findAll(this.QuestionList, 'documentquestionfields').find(x => x.documentQuestionFieldId == this.previousQuestionFields.documentQuestionFieldId) : this._commonService.findAll(this.QuestionList, 'documentquestionfollowup').find(x => x.documentQuestionFieldId == this.previousQuestionFields.documentQuestionFieldId);
      if (questionField) {
        let dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId == questionField.documentQuestionFieldDataTypeId);
        questionField.Code = dataType.Code;
        if (questionField.Code == "DocQuestionFieldDataType_Companies" || questionField.Code == "DocQuestionFieldDataType_ContractCompanies" || questionField.Code == "DocQuestionFieldDataType_ContractPersons") {
          if (this.previousQuestionFields.documentQuestionFieldValueId) {
            let index = questionField.documentTemplateFieldMapping.findIndex((item, index) => { return item.documentQuestionDataTypeMappingId == this.previousQuestionFields.documentQuestionFieldValueId });
            questionField.documentTemplateFieldMapping.splice(index, 1);
            questionField.isModified = true;
          }
        } else if(this.bookmarkValue.DocumentBookmarkTypeCode == "DocTempDataType_Optional" && (questionField.Code == "DocQuestionFieldDataType_SelectionList" || questionField.Code == "DocQuestionFieldDataType_RadioGroup" )) {
          if(this.previousQuestionFields.documentQuestionFieldValueId) {
            let fieldValue = questionField.children.find(x => x.documentQuestionFieldValueId == this.previousQuestionFields.documentQuestionFieldValueId);
            let templateFieldIds = fieldValue.documentTemplateFieldIds;
            let index = templateFieldIds.findIndex((item, index) => { return item == this.bookmarkValue.documentTemplateFieldId });
            if (index != -1) {
              templateFieldIds.splice(index, 1);
            }
            if (templateFieldIds.length == 0) {
              fieldValue.documentTemplateFieldIds = [];
            } else {
              fieldValue.documentTemplateFieldIds = [];
              templateFieldIds.forEach(element => {
                fieldValue.documentTemplateFieldIds.push(element);
              });
            }
            fieldValue.isModified = true;
          }
        } else {
          let templateFieldIds = questionField.documentTemplateFieldIds;
          let index = templateFieldIds.findIndex((item, index) => { return item == this.bookmarkValue.documentTemplateFieldId });
          if (index != -1) {
            templateFieldIds.splice(index, 1);
          }
          if (templateFieldIds.length == 0) {
            questionField.documentTemplateFieldIds = [];
          } else {
            questionField.documentTemplateFieldIds = [];
            templateFieldIds.forEach(element => {
              questionField.documentTemplateFieldIds.push(element);
            });
          }
          questionField.isModified = true;
        }
      }

    }
    if(this.bookmarkValue.documentQuestionTemplateFields && this.bookmarkValue.documentQuestionTemplateFields.length > 0 && this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId) {
      //add new link
      let questionField = this._commonService.findAll(this.QuestionList, 'documentquestionfields').find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      if(!questionField) {
        questionField = this._commonService.findAll(this.QuestionList, 'documentquestionfollowup').find(x => x.documentQuestionFieldId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldId);
      }
      let dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId == questionField.documentQuestionFieldDataTypeId);
      questionField.Code = dataType ? dataType.Code : null;
      if(questionField && (questionField.Code == "DocQuestionFieldDataType_Companies" || questionField.Code == "DocQuestionFieldDataType_ContractCompanies" || questionField.Code == "DocQuestionFieldDataType_ContractPersons")) {
        if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId) {
          var obj = {
            documentQuestionDataTypeMappingId: this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId,
            documentQuestionTemplateFieldId: uuid.v4(),
            documentTemplateFieldId: this.bookmarkValue.documentTemplateFieldId
          }
          if(!questionField.documentTemplateFieldMapping) {
            questionField.documentTemplateFieldMapping = [];
          }
          questionField.documentTemplateFieldMapping.push(obj);
          questionField.isModified = true;
        }
      } else if(this.bookmarkValue.DocumentBookmarkTypeCode == "DocTempDataType_Optional" && (questionField.Code == "DocQuestionFieldDataType_SelectionList" || questionField.Code == "DocQuestionFieldDataType_RadioGroup" )) {
        if(this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId) {
          let fieldValue = questionField.children.find(x => x.documentQuestionFieldValueId == this.bookmarkValue.documentQuestionTemplateFields[0].documentQuestionFieldValueId);
          let templateFieldIds = fieldValue.documentTemplateFieldIds;
          templateFieldIds.push(this.bookmarkValue.documentTemplateFieldId);
          fieldValue.documentTemplateFieldIds = [];
          templateFieldIds.forEach(element => {
            fieldValue.documentTemplateFieldIds.push(element);
          });
          fieldValue.isModified = true;
        }
      } else {
        let templateFieldIds = questionField.documentTemplateFieldIds;
        templateFieldIds.push(this.bookmarkValue.documentTemplateFieldId);
        questionField.documentTemplateFieldIds = [];
        templateFieldIds.forEach(element => {
          questionField.documentTemplateFieldIds.push(element);
        });
        questionField.isModified = true;
      }

    }
    let temp = JSON.stringify(this.bookmarkValue.documentQuestionTemplateFields[0]);
    this.previousQuestionFields = JSON.parse(temp);
  }

  updateBookmarkTree(event, selectedNode) {
    if(!event) {
      if(this.previousBookmarkValue && this.previousBookmarkValue.length > 0) {
        //remove previous link
        this.removeBookmarkLink(this.previousBookmarkValue, selectedNode);
      }
      if(selectedNode.documentTemplateFieldIds && selectedNode.documentTemplateFieldIds.length > 0) {
        //add new link
        this.addBookmarkLink(selectedNode);
      }
      this.previousBookmarkValue = selectedNode.documentTemplateFieldIds;
    }
  }

  removeBookmarkLink(previousValue, selectedNode) {
    for (var i = 0; i < previousValue.length; i++) {
      let bookmark = this.filterArray(this.templateFieldList, 'documentTemplateFieldId', previousValue[i]);
      for (var j = 0; j < bookmark.length; j++) {
        let questionFields = bookmark[j].documentQuestionTemplateFields;
        for (var k = 0; k < questionFields.length; k++) {
          if (questionFields[k].documentQuestionFieldId == selectedNode.documentQuestionFieldId) {
            questionFields.splice(k, 1);
          }
        }
        if(questionFields.length == 0){
          let obj = {
            documentQuestionId: null,
            documentQuestionFieldId: null,
            documentQuestionFieldValueId: null
          }
          questionFields.push(obj);
          bookmark[j].iconColor = 'red';
          this.updateParentNode(bookmark[j]);
        }
      }
    }
  }

  addBookmarkLink(selectedNode) {
    let selectedQuestionFields = selectedNode.documentTemplateFieldIds;
    selectedQuestionFields.forEach(element => {
      let linkedNode = this.findLinkedNode(this.QuestionList[0].children, element);
      linkedNode.forEach(node => {
        if(node.type.toLowerCase() == "documentquestionfieldvalues" && selectedNode.documentQuestionFieldValueId != node.documentQuestionFieldValueId) {
          let index = node.documentTemplateFieldIds.findIndex((item, index) => { return item == element });
          if (index != -1) {
            node.documentTemplateFieldIds.splice(index, 1);
          }
        } else if(selectedNode.documentQuestionFieldId != node.documentQuestionFieldId){
          let index = node.documentTemplateFieldIds.findIndex((item, index) => { return item == element });
          if (index != -1) {
            node.documentTemplateFieldIds.splice(index, 1);
          }
        }
      });

    });
    for(var i=0; i< selectedQuestionFields.length;i++) {
      let bookmark = this.filterArray(this.templateFieldList, 'documentTemplateFieldId', selectedQuestionFields[i]);
      for(var j=0; j< bookmark.length;j++) {
        if(!bookmark[j].documentQuestionTemplateFields) {
          bookmark[j].documentQuestionTemplateFields = [{
            documentQuestionId: null,
            documentQuestionFieldId: null,
            documentQuestionFieldValueId: null
          }]
        }
        let questionFields = bookmark[j].documentQuestionTemplateFields;
        if(questionFields.length == 0) {
          let obj = {
            documentQuestionId: null,
            documentQuestionFieldId: null,
            documentQuestionFieldValueId: null
          }
          questionFields.push(obj);
        }
        questionFields[0].documentQuestionId = selectedNode.type == "DocumentQuestionFieldValues" ? selectedNode.parent.documentQuestionId : selectedNode.documentQuestionId;
        questionFields[0].documentQuestionFieldId = selectedNode.documentQuestionFieldId;
        questionFields[0].documentQuestionFieldValueId = selectedNode.documentQuestionFieldValueId ? selectedNode.documentQuestionFieldValueId : null;


        if(questionFields.length > 0) {
          bookmark[j].iconColor = 'green';
          this.updateParentNode(bookmark[j]);
        }
      }
    }
  }

  updateMappingValue(element) {
    if(element.documentTemplateFieldId && element.documentQuestionDataTypeMappingId) {
      let bookmark = this.filterArray(this.templateFieldList, 'documentTemplateFieldId', element.documentTemplateFieldId);
      let dataType = this.questionFieldDataType.find(x => x.DocumentQuestionFieldDataTypeId == this.selectedFiles[0].documentQuestionFieldDataTypeId);
      if(bookmark) {
        if(bookmark[0].documentQuestionTemplateFields && bookmark[0].documentQuestionTemplateFields.length > 0) {
          bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldId = this.selectedFiles[0].documentQuestionFieldId;
          bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldValueId = element.documentQuestionDataTypeMappingId;
          bookmark[0].documentQuestionTemplateFields[0].documentQuestionId = this.selectedFiles[0].documentQuestionId;
          bookmark[0].documentQuestionTemplateFields[0].documentQuestionFieldDataType = dataType.Code;
          bookmark[0].iconColor = 'green';
          this.updateParentNode(bookmark[0]);
        } else {
          let obj = {
            documentQuestionFieldId: this.selectedFiles[0].documentQuestionFieldId,
            documentQuestionFieldValueId: element.documentQuestionDataTypeMappingId,
            documentQuestionId: this.selectedFiles[0].documentQuestionId,
            documentQuestionFieldDataType: dataType.Code
          }
          bookmark[0].documentQuestionTemplateFields.push(obj);
          bookmark[0].iconColor = 'green';
          this.updateParentNode(bookmark[0]);
        }
      }
    }
  }

  findFilter(arr, term) {
    var matches = [];
    if (!Array.isArray(arr)) return matches;

    arr.forEach(i => {
        if (!i.label) {
            matches.push(i);
        } else if(i.label.trim() == term) {
          matches.push(i);
        } else {
            let childResults = this.findFilter(i.children, term);
            if (childResults.length)
            matches = [ ...matches, ...childResults];
        }
    })

    return matches;
  }

  filterArray(arr, key, value) {
    var matches = [];
    if (!Array.isArray(arr)) return matches;

    arr.forEach(i => {
      if(i[key] == value) {
        matches.push(i);
      } else {
          let childResults = this.filterArray(i.children, key, value);
          if (childResults.length)
          matches = [ ...matches, ...childResults];
      }
  })

  return matches;
  }

  findLinkedNode(arr, term) {
    var matches = [];
    if (!Array.isArray(arr)) return matches;

    arr.forEach(i => {
        if (i.documentTemplateFieldIds && i.documentTemplateFieldIds.length > 0 && i.documentTemplateFieldIds.includes(term)) {
            matches.push(i);
            let childResults = this.findLinkedNode(i.children, term);
            if (childResults.length)
            matches = [ ...matches, ...childResults];
        } else {
            let childResults = this.findLinkedNode(i.children, term);
            if (childResults.length)
            matches = [ ...matches, ...childResults];
        }
    })

    return matches;
  }


  linkedFields(selected) {
    let result = [];
    if(selected) {
      selected.documentTemplateFieldIds.forEach(element => {
        let template = this.documentTemplateFieldList.find(x=> x.DocumentTemplateFieldId == element && x.DocumentBookmarkType && x.DocumentBookmarkType.indexOf('_Replacement') != -1);
        if(template) {
          result.push(template);
        }
      });
    }
    return result;
  }
}
